import {useState, useEffect} from "react"

export const Player = ({player, handleClick}) => {

    //TODO: handle responsive a bit better
    const [width, setWindowWidth] = useState(0);
    const [isSmallScreen, setIsSmallScreen] =useState(false)
    const currentYear = new Date().getFullYear()

    const updateDimensions = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      
      if (width < 500) {
        setIsSmallScreen(true)
      } else {
        setIsSmallScreen(false)
      }
    }

    useEffect(() => { 
        updateDimensions();
        window.addEventListener("resize", updateDimensions);
        return () => 
          window.removeEventListener("resize",updateDimensions);
       }, [width])
    
    const yearDisplayStyleClass = `is-flex ${isSmallScreen && "is-flex-direction-column is-align-items-center"}`
    
    return (
        <div className={`is-flex is-justify-content-space-between ${isSmallScreen && "is-flex-direction-column"}`} style={{margin: "1rem", padding: ".5rem", backgroundColor: "lightgrey"}}>
            <span style={{fontWeight: "bold", fontSize: "85%"}} className={isSmallScreen ? "is-flex is-justify-content-center" : ""}>{player.name}</span>
            <div className={`is-flex is-justify-content-right is-align-items-center ${isSmallScreen && "is-flex-direction-column"}`}>
                <div className="is-flex is-justify-content-center">
                    <span style={smallFontStyle} className={yearDisplayStyleClass}><b>{currentYear}:</b><span>{player.year1}</span></span>
                    <span style={smallFontStyle} className={yearDisplayStyleClass}><b>{currentYear + 1}:</b><span>{player.year2}</span></span>
                    <span style={smallFontStyle} className={yearDisplayStyleClass}><b>{currentYear + 2}:</b><span>{player.year3}</span></span>
                </div>
                <div>
                    <span style={{fontWeight: "bold", color: "#d61f36"}}>{player.total}</span>
                    {handleClick && (
                        <span style={{paddingLeft: ".5rem", marginLeft: ".5rem", borderLeft: "1px solid grey"}} >
                            <button style={{cursor: "pointer"}} className="delete" onClick={() => handleClick({item: player})}/>
                        </span>
                    )}
                </div>
            </div>
        </div> 
    )
}

const smallFontStyle = {
    fontSize: ".5rem",
    paddingRight: "1rem"
}